import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TimerState {
  seconds: number;
  isRunning: boolean;
}

const initialState: TimerState = {
  seconds: 1800,
  isRunning: false,
};

const timerSlice = createSlice({
  name: 'timer',
  initialState,
  reducers: {
    startTimer(state) {
      state.isRunning = true;
    },
    stopTimer(state) {
      state.isRunning = false;
    },
    resetTimer(state) {
      state.seconds = 1800;
      state.isRunning = false;
    },
    tick(state) {
      if (state.seconds > 0) {
        state.seconds -= 1;
      } else {
        state.isRunning = false;
      }
    },
    setSeconds(state, action: PayloadAction<number>) {
      state.seconds = action.payload;
    },
  },
});

export const { startTimer, stopTimer, resetTimer, tick, setSeconds } =
  timerSlice.actions;
export default timerSlice.reducer;
